export const isWechat: boolean = /MicroMessenger/i.test(navigator.userAgent);
// export const isWechat: boolean = true;

export const compareVersion = (version_1: string, version_2: string) => {
    try {
        const versions_1 = version_1.split('.');
        const versions_2 = version_2.split('.');
        const length = Math.min(versions_1.length, versions_2.length);
        for (let i = 0; i < length; i++) {
            if (Number(versions_1[i]) === Number(versions_2[i])) {
                continue
            } else if (Number(versions_1[i]) > Number(versions_2[i])) {
                return true;
            } else {
                return false
            }
        }
        return false;
    } catch(e) {
        return true
    }
}

export const getWorkNumber = (curDate: Date) => {
    let hours: any = curDate.getHours();
    if (hours < 10) {
        hours = '0' + hours;
    }
    let minutes: any = curDate.getMinutes();
    if (minutes < 10) {
        minutes = '0' + minutes;
    }

    return `${hours}${minutes}`;
}

export const getGetOffWorkTime = (curDate: Date) => {
    let hours: any = curDate.getHours();
    if (hours < 10) {
        hours = '0' + hours;
    }
    let minutes: any = curDate.getMinutes();
    if (minutes < 10) {
        minutes = '0' + minutes;
    }

    let month: any = curDate.getMonth() + 1;
    if (month < 10) {
        month = '0' + month
    }

    let days: any = curDate.getDate();
    if (days < 10) {
        days = '0' + days;
    }

    return `${month}月${days}日 ${hours}:${minutes}`
}

export const isNetease = (account: string) => {
    return account.indexOf('@163.com') > -1 
    || account.indexOf('@126.com') > -1
    || account.indexOf('@yeah.net') > -1
    || account.indexOf('@188.com') > -1
    || account.indexOf('@vip.126.com') > -1
    || account.indexOf('@vip.163.com') > -1
    || account.indexOf('@vip.188.com') > -1
}

export const ellipsisAccount = (account: string | undefined) => {
    if (!account) return '';
    let prefix = account.split('@')[0];
    let suffix = account.split('@')[1];
    if (account.length > 15) {
        if (suffix.length < 15) {
            return prefix.slice(0, 15 - (suffix.length + 1)) + '...@' + suffix; 
        } else {
            return prefix[0] + '...@' + suffix;
        }
    } else {
        return account;
    }
}

export const ellipsisNickname = (nickname: string | undefined) => {
    if (!nickname) return '';
    if (nickname.length > 10) {
        return nickname.slice(0, 3) + '...' + nickname.slice(nickname.length - 2); 
    } else {
        return nickname;
    }
}

export const markAccount = (account: string | undefined) => {
    if (!account) return '';
    let prefix = account.split('@')[0];
    let suffix = account.split('@')[1];
    if (prefix.length > 2) {
        return prefix.slice(0, 2) + '***@' + suffix;
    }
    return prefix[0] + '*@' + suffix;
}

export const markPhone = (phone: string | undefined) => {
    if (!phone) return '';
    if (phone.length > 7) {
        return phone.slice(0, 3) + '***' + phone.slice(phone.length - 4);
    }
    return phone;
}

export function getQueryString(str:string, search?: string) {
    const t = new RegExp('(^|&)' + str + '=([^&]*)(&|$)', 'i');
    const paramStr = decodeURI(search || window.location.search);
    const n = paramStr.substr(1).match(t);
    // eslint-disable-next-line no-useless-escape
    const rgExp = /(\>|\<|\'|\\|\\\\)/ig;

    if (n != null && !rgExp.test(n[2])) {
        return unescape(n[2]);
    }
    return '';
}

export function isIEVersion() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1; //判断是否IE11浏览器
    if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
            return 7;
        } else if (fIEVersion == 8) {
            return 8;
        } else if (fIEVersion == 9) {
            return 9;
        } else if (fIEVersion == 10) {
            return 10;
        } else {
            return 6;//IE版本<=7
        }
    } else if (isEdge) {
        return 'edge';//edge
    } else if (isIE11) {
        return 11; //IE11  
    } else {
        return -1;//不是ie浏览器
    }
}
